(() => {
  if(window.rorilioCartUpsell) return;
  window.rorilioCartUpsell=true;
  let busy=false;
  const root=()=>window.Shopify?.routes?.root || '/';
  function render(cart) {
    if(!cart.sections?.['cart-drawer'] || !cart.sections?.['cart-icon-bubble']) return false;
    document.querySelector('cart-drawer').renderContents(cart);
    if(typeof publish==='function') publish(PUB_SUB_EVENTS.cartUpdate,{source:'cart-items',cartData:cart});
    return true;
  }
  async function refresh() {
    const url=new URL(location.href);url.searchParams.set('sections','cart-drawer,cart-icon-bubble');
    const response=await fetch(url,{cache:'no-store'});
    return response.ok && render({sections:await response.json()});
  }

  // Price the offer through Shopify without adding anything to the shopper's cart.
  const quotedNodes=new WeakSet();
  const memoryQuotes=new Map();
  async function quoteOffer(node) {
    if(quotedNodes.has(node)) return;
    quotedNodes.add(node);
    const country=node.dataset.country,currency=node.dataset.currency;
    const target='gid://shopify/ProductVariant/'+node.dataset.offerVariant;
    const trigger='gid://shopify/ProductVariant/'+node.dataset.triggerVariant;
    const cacheKey=['rorilio-single-offer-v1',country,currency,target,trigger,node.dataset.regularCents].join(':');
    const cached=memoryQuotes.get(cacheKey);
    function apply(amount) {
      const regular=Number(node.dataset.regularCents)/100;
      if(!Number.isFinite(amount)||amount<=0||amount>=regular) {node.hidden=true;return;}
      node.querySelector('[data-rr-offer-price]').textContent=new Intl.NumberFormat(country==='CO'?'es-CO':'es-MX',{style:'currency',currency}).format(amount)+' '+currency;
      node.querySelector('[data-rr-upsell-id]').disabled=false;
    }
    if(cached && Date.now()-cached.time<60000) {apply(cached.amount);return;}
    try {
      const response=await fetch('/api/2026-07/graphql.json',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({query:'mutation($input:CartInput!){cartCreate(input:$input){cart{lines(first:5){nodes{merchandise{... on ProductVariant{id}}cost{totalAmount{amount currencyCode}}discountAllocations{discountedAmount{amount currencyCode}}}}}userErrors{message}}}',variables:{input:{buyerIdentity:{countryCode:country},lines:[{merchandiseId:trigger,quantity:1},{merchandiseId:target,quantity:1}]}}})});
      const result=await response.json();
      const payload=result.data?.cartCreate;
      if(!response.ok||result.errors?.length||payload?.userErrors?.length) throw new Error('quote');
      const line=payload.cart?.lines.nodes.find(l=>l.merchandise.id===target);
      if(!line||line.cost.totalAmount.currencyCode!==currency||!line.discountAllocations.some(d=>Number(d.discountedAmount.amount)>0)) throw new Error('no-offer');
      const amount=Number(line.cost.totalAmount.amount);
      memoryQuotes.set(cacheKey,{amount,time:Date.now()});
      apply(amount);
    } catch(_) {node.hidden=true;}
  }
  function findOffers() {document.querySelectorAll('[data-rr-offer-quote]').forEach(quoteOffer);}
  new MutationObserver(findOffers).observe(document.documentElement,{childList:true,subtree:true});
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',findOffers,{once:true}); else findOffers();

  document.addEventListener('click',async event=>{
    const button=event.target.closest?.('[data-rr-upsell-id]');
    if(!button) return;
    event.preventDefault();
    const drawer=button.closest('cart-drawer');
    if(busy || drawer.getAttribute('aria-busy')==='true' || drawer.querySelector('.cart__items--disabled')) return;
    busy=true;drawer.setAttribute('aria-busy','true');
    const controls=[...drawer.querySelectorAll('input,select,button:not(.drawer__close)')].map(el=>[el,el.disabled]);controls.forEach(([el])=>el.disabled=true);
    button.querySelector('span').textContent='Agregando…';
    const error=drawer.querySelector('.rr-upsell-error');error.hidden=true;
    let attempted=false;
    try {
      const current=await fetch(root()+'cart.js',{cache:'no-store'});
      if(!current.ok) throw new Error('No se pudo consultar el carrito. Inténtalo de nuevo.');
      const cart=await current.json();
      if(cart.items.some(item=>String(item.product_id)===button.dataset.rrUpsellProduct)) {await refresh();return;}
      attempted=true;
      const response=await fetch(root()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:button.dataset.rrUpsellId,quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
      const added=await response.json();
      if(!response.ok || added.status) throw new Error(added.description || 'No se pudo agregar el producto. Inténtalo de nuevo.');
      if(!render(added) && !await refresh()) location.reload();
    } catch(e) {
      if(attempted) {try {await refresh();} catch(_) {}}
      const currentError=document.querySelector('.rr-upsell-error');
      if(currentError) {currentError.hidden=false;currentError.textContent=e.message || 'No se pudo agregar el producto. Inténtalo de nuevo.';}
    } finally {
      controls.forEach(([el,disabled])=>el.disabled=disabled);
      if(button.isConnected) button.querySelector('span').textContent='Agregar +';
      drawer.removeAttribute('aria-busy');busy=false;
    }
  });
})();
